
import { Options, Vue } from 'vue-class-component'
import TextParticle from '@/components/TravelText.vue'
import PicParticles from '@/utils/PicParticles'
import TravelCountry from './Country.vue'
import { CountUp } from 'countup.js'
import { Odometer } from 'odometer_countup';

let bbx, travelBg, indexTitle;
let peopleAnimations = [
  'fadeIn',
  'fadeInDown',
  'fadeInDownBig',
  'fadeInLeft',
  'fadeInLeftBig',
  'fadeInRight',
  'fadeInRightBig',
  'fadeInUp',
  'fadeInUpBig',
  'fadeInTopLeft',
  'fadeInTopRight',
  'fadeInBottomLeft',
  'fadeInBottomRight',
]
@Options({
  name: 'TravelIndex',
  components: {
    TextParticle,
    TravelCountry,
  },
  props: {},
  data() {
    return {
      isShow: false,
      isShowTitle: false,
      countryCount: 37,
      isEndTravelPlay: false,
      peopleTypeClass: 'five-p',
      peopleAnimations: [],
      peopleAnimationsName: [],
      peopleAnimationsTimes: [],
      peopleAnimationsDes: [],
      rjPeople: 375,
      isShowMqCountry: false,
      isShowTag: false,
      isShowMqrj: 0,
      isShowMqPeopleList: false,
      isShowMqGaige: false,
      isShowYouke: false,
      isShowCityStep: 0,
    }
  },
  created() {
    let names: any = [];
    let times: any = [];
    let des: any = [];
    for (let i = 0; i < 375; i++) {
      names.push(peopleAnimations[Math.floor(Math.random() * peopleAnimations.length)]);
      times.push((Math.random() * 1).toFixed(1));
      des.push((Math.random() * 1).toFixed(1));
    }

    this.peopleAnimationsName = names;
    this.peopleAnimationsTimes = times;
    this.peopleAnimationsDes = des;
  },
  computed: {},
  mounted() {
    this.isShow = true;
    this.$nextTick(() => {
      this.init();
    });
    // this.indexTitleParticle()
    // this.travelBg()
    // this.cityPeople()
    // this.mqCountry()
    // this.playCount()
    // this.youke()
    // this.rujing()
  },
  beforeDestroy() {
    indexTitle.forceDestroy();
    bbx.forceDestroy();
    travelBg.forceDestroy();
  },
  methods: {
    init() {
      this.travelBg();
      const _this = this;
      const vw = window.innerWidth;
      const vh = window.innerHeight;

      let isShowTravelTitle = false;  // 是否显示旅游标题
      let isShowCity = false;  // 是否显示city文案
      let isShowBbx = false;  // 是否显示保保熊画像
      let isShowMqKouan = false;  // 是否显示免签口岸
      let isShowMqCountry = false;  // 是否显示免签国家
      let isShowTag = false;  // 是否显示旅游标签
      let isShowRjPeople = false;  // 是否显示入境游客
      let isShowTese = false;  // 是否显示特色之路
      let isShowYouke = false;  // 是否显示游客数据
      window.addEventListener('scroll', () => {
        const cityTop = document.querySelector('.travel-city')?.getBoundingClientRect().top || 0;
        // 旅游标题
        if (!isShowTravelTitle) {
          const travelTitleTop = document.querySelector('.travel-title')?.getBoundingClientRect().top;
          if (travelTitleTop && travelTitleTop < vh / 2) {
            isShowTravelTitle = true;
          }
        }

        if (cityTop < 0 && travelBg) {
          travelBg.forceDestroy();
          travelBg = null;
        }

        if (cityTop > 0 && !travelBg) {
          _this.travelBg();
        }

        if (cityTop > 0 && isShowCity) {
          _this.isShowCityStep = 0;
          isShowCity = false;
        }

        if (!isShowCity) {
          if (cityTop < vh / 2) {
            _this.isShowCityStep = 1;
          }

          if (cityTop < vh / 4) {
            _this.isShowCityStep = 2;
          }

          if (cityTop < vh / 8) {
            _this.isShowCityStep = 3;
            isShowCity = true;
          }
        }

        /* if (isShowTravelTitle) {
          if (travelTitleTop && travelTitleTop < 0) {
            // travelBg.forceDestroy();
          }
        } */

        // 保保熊画像
        if (!isShowBbx) {
          const bbxTop = document.querySelector('#bbx')?.getBoundingClientRect().top;
          if (bbxTop && bbxTop < vh / 1.5) {
            _this.cityPeople();
            isShowBbx = true;
          }
        }

        const mqCountryTop = document.querySelector('.travel-mq')?.getBoundingClientRect().top;
        // 免签
        if (!isShowMqKouan && isShowBbx) {
          if (mqCountryTop && mqCountryTop < vh / 1.5 && mqCountryTop > vh / 4) {
            isShowMqKouan = true;
            isShowMqCountry = false;
            _this.isShowMqCountry = true;
            _this.countryCount = 37;
            _this.$nextTick(() => {
              _this.mqCountry();
            });
          }
        }

        // 免签国家
        if (!isShowMqCountry && isShowBbx) {
          if (mqCountryTop && mqCountryTop <  vh / 4) {
            isShowMqCountry = true;
            isShowMqKouan = false;
            _this.isShowMqCountry = true;
            _this.countryCount = 54;
            _this.$nextTick(() => {
              _this.mqCountry();
            });
          }
        }

        // 旅游标签
        if (!isShowTag) {
          const tagTop = document.querySelector('.travel-play')?.getBoundingClientRect().top;
          if (tagTop && tagTop < vh / 2) {
            isShowTag = true;
            _this.isShowTag = true;
            _this.$nextTick(() => {
              _this.playCount();
            });
          }
        }

        // 入境
        const rjPeopleTop = document.querySelector('.travel-rujing-content')?.getBoundingClientRect().top;
        if (!isShowRjPeople && isShowTag) {
          if (rjPeopleTop && rjPeopleTop < vh && rjPeopleTop > vh / 4 && _this.isShowMqrj !== 1) {
            _this.isShowMqrj = 1;
            _this.$nextTick(() => {
              _this.rujing();
            });
          }

          if (rjPeopleTop && rjPeopleTop < vh / 2) {
            _this.isShowMqPeopleList = true;
            isShowRjPeople = true;
          }

          /* if (rjPeopleTop && rjPeopleTop < vh / 4 && _this.isShowMqrj !== 2) {
            _this.isShowMqrj = 2;
            _this.$nextTick(() => {
              _this.mqRujing();
            });
          } */
        }

        if (!isShowTese) {
          const teseTop = document.querySelector('.travel-gaige')?.getBoundingClientRect().top;
          if (teseTop && teseTop < vh) {
            isShowTese = true;
            _this.isShowMqGaige = true;
          }
        }

        // 游客
        if (!isShowYouke) {
          const youkeTop = document.querySelector('.travel-youke')?.getBoundingClientRect().top;
          if (youkeTop && youkeTop < vh / 2) {
            isShowYouke = true;
            _this.isShowYouke = true;
            _this.$nextTick(() => {
              _this.youke();
            });
          }
        }
      }, false)
    },
    indexTitleParticle() {
      const _this = this;
      indexTitle = new PicParticles({
        container: document.querySelector('#index-title'),
        imgUrl: require('../../assets/img/title.png'),
        pix: 5,
        duration: 2000
      })

      setTimeout(() => {
        _this.isShowTitle = true
      }, 2000);
    },
    cityPeople() {
      bbx = new PicParticles({
        container: document.querySelector('#bbx'),
        imgUrl: require('../../assets/img/bbx.png'),
        pix: 20,
        duration: 2000
      })
    },
    // 免签国家
    mqCountry() {
      const countUp = new CountUp('mqCountry', this.countryCount);
      countUp.start();
    },
    // 视频播放量
    playCount() {
      this.isEndTravelPlay = false;
      const _this = this;
      const countUp = new CountUp('travel-play-count', 1000000000, {
        // plugin: new Odometer({ duration: 2.3, lastDigitDelay: 0 }),
        useGrouping: false,
        duration: 3,
        onCompleteCallback() {
          _this.isEndTravelPlay = true;
        }
      });
      countUp.start();
    },
    // 入境人数
    entryPeople() {
      let isMqrj = false;
      this.rujing();

      setInterval(() => {
        if (!isMqrj) {
          this.isShowMqrj = 2;
          this.$nextTick(() => {
            this.mqRujing();
          });
          isMqrj = true;
        } else {
          this.isShowMqrj = 1;
          this.$nextTick(() => {
            this.rujing();
          });
          isMqrj = false;
        }
      }, 5000);
    },
    // 入境外国人
    rujing() {
      const countUp = new CountUp('rj-count', 1463.5, {
        useGrouping: false,
        // 小数位数
        decimalPlaces: 1,
        // 小数点
        decimal: '.',
      });
      countUp.start();
      const rjBfb = new CountUp('rj-count-bfb', 152.7, {
        // 小数位数
        decimalPlaces: 1,
        // 小数点
        decimal: '.',
        // 后缀
        suffix: '%',
      });
      rjBfb.start();
    },
    // 免签入境
    mqRujing() {
      new CountUp('mq-rj', 854.2, {
        useGrouping: false,
        decimalPlaces: 1,
        decimal: '.',
      }).start();

      new CountUp('mq-zb', 52, {
        decimalPlaces: 1,
        decimal: '.',
        suffix: '%',
      }).start();

      new CountUp('mq-tb', 190.1, {
        decimalPlaces: 1,
        decimal: '.',
        suffix: '%',
      }).start();
    },
    // 国内游客数据
    youke() {
      const duration = 3;
      new CountUp('travel-year', 2023, {
        useGrouping: false,
        startVal: 2004,
        duration,
        useEasing: false,
      }).start();

      new CountUp('t-yk', 4891, {
        useGrouping: false,
        startVal: 1102,
        duration,
        useEasing: false,
      }).start();

      new CountUp('t-hf', 49133.1, {
        useGrouping: false,
        decimalPlaces: 1,
        decimal: '.',
        startVal: 4710.7,
        duration,
        useEasing: false,
      }).start();
    },
    travelBg() {
      if (travelBg) {
        travelBg.forceDestroy();
      }
      // travel-bg
      travelBg = new PicParticles({
        container: document.querySelector('#travel-bg'),
        imgUrl: require('../../assets/img/t_title_bg.png'),
        pix: 30,
        radius: 60,
        duration: 3000
      })
    },
  },
})
export default class Travelindex extends Vue {

}
